type Props = {
  origin: { id: number; name: string } | null | undefined;
};

export default function OriginBadge({ origin }: Props) {
  if (!origin) return null;
  return <span className='origin-badge'>{origin.name}</span>;
}
